import React from "react";
import MyDatePicker from "@components/Common/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getUniqueListBy } from "@components/Common/Function";
import { clusterCodePlaceHolder } from "@components/Common/Constant";
import { getMinWorkingDate } from "./dateWindow";

const DateSection = ({
  formData,
  onChange,
  setCurrentSelectedDate,
  submittedHighlightedDates,
  draftHighlightedDates,
  formValidation,
  cluster,
  setCluster,
  clusterCodeOption,
  userType,
  disable,
}) => {
  const clusterFilterData = getUniqueListBy(
    clusterCodeOption,
    userType === "MH3" || userType === "RBDM Collaborator"
      ? "CLUSTER_CODE__c"
      : "SH3_Name__c"
  );

  const handleClusterChange = (e, newValue) => {
    setCluster(newValue);
    const clusterCode =
      userType === "MH3" || userType === "RBDM Collaborator"
        ? newValue?.CLUSTER_CODE__c
        : newValue?.SH3_Code__c;

    onChange({
      target: {
        name: "clusterCode",
        value: clusterCode,
      },
    });
  };

  return (
    <>
      {/* Date Selection */}
      <div className="flex flex-col gap-1 mb-1">
        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
          Date of visit
          <span className="text-red-500 ml-1">*</span>
        </label>
        <MyDatePicker
          name="marketVisitDate"
          selectedDate={formData?.marketVisitDate || ""}
          setDate={(e) => {
            setCurrentSelectedDate(e?.target?.value);
            onChange(e);
          }}
          createdDates={submittedHighlightedDates}
          draftDates={draftHighlightedDates}
          minDate={getMinWorkingDate()}
        />
        {!formData?.marketVisitDate && formValidation?.marketVisitDate && (
          <p className="text-red-500 text-xs mt-1">
            {formValidation?.marketVisitDate}
          </p>
        )}
      </div>

      {/* Cluster Code Selection - for specific user types */}
      {(userType === "SH6" ||
        userType === "SH5" ||
        userType === "SH7" ||
        userType === "MH3" ||
        userType === "RBDM Collaborator" ||
        userType === "HO Collaborator" ||
        userType === "TMM" ||
        userType === "HO Auditor") && (
        <div className="flex flex-col gap-1 mb-1">
          <Autocomplete
            value={
              cluster?.SH3_Name__c !== clusterCodePlaceHolder?.SH3_Name__c
                ? cluster
                : null
            }
            id="cluster-code"
            className="myDealer__categorySelect"
            options={
              !clusterCodeOption || clusterCodeOption?.length === 0
                ? [{ SH3_Name__c: "Loading..." }]
                : clusterFilterData
            }
            getOptionLabel={(option) =>
              userType === "MH3" || userType === "RBDM Collaborator"
                ? `${option?.Cluster_Description__c || ""} : ${option?.CLUSTER_CODE__c || ""}`
                : `${option?.SH3_Name__c || ""} : ${option?.SH3_Code__c || ""}`
            }
            onChange={handleClusterChange}
            renderInput={(params) => <TextField {...params} placeholder="Select Cluster" />}
            disabled={disable}
          />
          {!formData?.clusterCode && formValidation?.clusterCode && (
            <p className="text-red-500 text-xs mt-1">
              {formValidation?.clusterCode}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default DateSection;
